<template>
  <a class="btn_back pointer" @click="back"></a>
</template>

<script>
  import {SET_SELECTED_CATEGORY} from '@/store/mutations.type'

  export default {
    name: 'BackButton',
    computed: {
      parent() {
        if (!this.$store.getters.selectedCategory) {
          return null
        }
        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].id === this.$store.getters.selectedCategory.parent_id) {
            if (!this.$store.getters.categories[i].id) // из подкатегорий не возвращать на страницу "Все категории". Нужно сразу отправлять на главную
                return null
            return this.$store.getters.categories[i]
          }
        }
        return null
      },

      backText() {
        if (this.parent) {
          return this.parent.name
        }
        return this.text('go_home')
      }
    },
    methods: {
      back() {
        if (this.parent) {
          return this.$store.commit(SET_SELECTED_CATEGORY, this.parent)
        }

        this.$router.push({name: 'home', params: {token: this.$store.getters.token}}).then(() => {
          this.$store.commit(SET_SELECTED_CATEGORY, null)
        })

      }

    }
  }
</script>

<style scoped>

</style>
